import { useAtticApiKeyListQuery } from "@dashboard/graphql";
import useListSettings from "@dashboard/hooks/useListSettings";
import useNavigator from "@dashboard/hooks/useNavigator";
import usePaginator, { createPaginationState } from "@dashboard/hooks/usePaginator";
import { ListViews } from "@dashboard/types";
import { mapEdgesToItems } from "@dashboard/utils/maps";

import AtticApiKeyListPage from "../components/AtticApiKeyListPage/AtticApiKeyListPage";
import { atticApiKeyListUrl, type AtticApiKeyListUrlQueryParams } from "../urls";

export const AtticApiKeyListView = ({ params }: { params: AtticApiKeyListUrlQueryParams }) => {
  const navigate = useNavigator();
  const { settings, updateListSettings } = useListSettings(ListViews.ATTIC_API_KEY_LIST);
  const { rowNumber } = settings;
  const paginationState = createPaginationState(rowNumber, params);
  // No totalCount: paging runs on cursors, like the activity log.
  const { data, loading, error } = useAtticApiKeyListQuery({
    variables: paginationState,
    fetchPolicy: "cache-and-network",
  });
  const connection = data?.atticApiKeys;
  const paginator = usePaginator({
    pageInfo: connection?.pageInfo,
    paginationState,
    queryString: params,
  });

  return (
    <AtticApiKeyListPage
      apiKeys={loading && !connection ? undefined : (mapEdgesToItems(connection) ?? [])}
      loadFailed={!!error && !connection}
      now={Date.now()}
      rowNumber={rowNumber}
      hasNextPage={paginator.hasNextPage ?? false}
      hasPreviousPage={paginator.hasPreviousPage ?? false}
      onRowNumberChange={value => {
        updateListSettings("rowNumber", value);
        navigate(atticApiKeyListUrl(), { replace: true });
      }}
      onNextPage={() => paginator.nextHref && navigate(paginator.nextHref)}
      onPreviousPage={() => paginator.prevHref && navigate(paginator.prevHref)}
    />
  );
};

export default AtticApiKeyListView;
